import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import UIManifest from "src/engine/ui/UIManifest";
import "./JIcon.scss";

interface IJIcon extends IBaseUI {
    style?: any;
    src: string;
    className?: string;
    onClick?: any;
    themeType?: "white" | "dark";
}
interface IState {}

const ThemeWhite = {
    edit: "05bbad2468abba45_886_32x32",
    delete: "f427b0e41edac231_993_32x32",
    setting: "6770391aa14b68a6_961_32x32",
    copy: "b584e4cdc948a44c_390_32x32",
    plus: "5ae75fdf5cdd843b_257_32x32",
    swap: "a35b893ef65d51f0_662_32x32",
    slack: "e9412c5aecc17a2a_207_32x32",
    import: "ec4744ac9c360540_571_32x32",
    search: "d7d6a70119120452_837_32x32",
    close: "cbec626e4d7949ba_281_32x32",
    "zoom-in": "c5654ddbb674a4d1_628_32x32",
    "zoom-out": "9f9dadda54c9d228_638_32x32",
    "rotate-right": "f44180d09a0c5ca6_434_32x32",
    "rotate-left": "4ff1ca96cccbf84d_444_32x32",
    right: "52595a09665539d4_329_32x32",
    left: "737990d5f0e66c82_428_32x32",
};

const ThemeDark = {
    home: "114a14136b0a4f32_5558_200x200",
    layout: "f8c76f47b41ef47f_1919_200x200",
    "menu-fold": "b32fbc736f2d4ad3_2348_200x200",
    menu: "b32fbc736f2d4ad3_2348_200x200",
    appstore: "ccbb9bd5a4fc83fa_3581_200x200",
    edit: "ce7f3ab4e3fcd228_796_32x32",
    "to-top": "4a44ff058c76c4d1_2411_200x200",
    sync: "87508e3e2f0398be_6230_200x200",
    delete: "162cb60a4d9ad8ac_903_32x32",
    setting: "4dab24682a75362f_1159_32x32",
    copy: "df537e65d20d9e35_406_32x32",
    plus: "6789bbc790ac715a_287_32x32",
    swap: "cad3bd2d8d0e87ae_740_32x32",
    slack: "246042ada5dc9197_211_32x32",
    import: "3063b1e47a426b4b_628_32x32",
    rollback: "e1aacc92c5209e5b_2605_200x200",
    search: "91feb0beab6c0b49_764_32x32",
};

const Themes = { white: ThemeWhite, dark: ThemeDark };

@UIManifest.declare("JIcon", "Icon图标", UIManifest.Type.JJ)
class JIcon extends BaseUI<IJIcon, IState> {
    render() {
        let { src = "", className = "", onClick, uiItem, themeType = "dark", ...other } = this.props;
        // if (!SrcMaps[src])
        //     console.log('[JIcon]:src', src);
        src = Themes[themeType]?.[src] || Themes.dark[src] || src;
        if (src.indexOf("//") < 0) src = `//webcloudplt.oss.jjbisai.com/fw/0/${src}.png`;
        return (
            <div style={this.getStyle({ display: "inline-block" })} className={`react-jicon-out ${className}`} onClick={onClick} {...other}>
                <img src={src} className={"react-jicon"} />
            </div>
        );
        // return <img src={src} className={"react-jicon " + className} style={this.getStyle()} onClick={onClick} />;
    }
}

export default JIcon;
